import { useMemo } from 'react';
import { SmartSendItemApiModel } from '~/lib/api/smartsend/types';
import { P2GChip } from '@parcel2go/core-ui';
import P2GContentDropDown from '../../P2GContentDropDown';
import ItemContentsIntro from '../edit/ItemContentsIntro';
import { P2GBox } from '@parcel2go/core-ui';
import {
  GetItemAccountNamesForMultiAccountSources,
  GetCollatedCustomerReferenceNumbers
} from './OrderReferenceNumberUtils';
import { GetSkus } from './GetSkus';
import { P2GTooltip } from '@parcel2go/core-ui';
import { useTranslation } from 'react-i18next';
import { TranslationNamespaces } from '~/lib/constants';

interface props {
  item: SmartSendItemApiModel;
  wrapper: (x: React.ReactNode) => React.ReactNode;
}

export default function ItemIds(props: props) {
  const { t } = useTranslation(TranslationNamespaces.SMARTSEND);
  const ids = useMemo(
    () => ({
      refs: GetCollatedCustomerReferenceNumbers(props.item.MarketplaceOrderLines),
      skus: GetSkus(props.item),
      accountNames: GetItemAccountNamesForMultiAccountSources(props.item)
    }),
    [props.item]
  );

  if (ids.refs.length === 0 && ids.skus.length == 0) {
    return null;
  }

  return props.wrapper(
    <P2GContentDropDown
      control={
        <P2GTooltip
          title={t('CLICK_TO_VIEW_REFERENCES_TOOLTIP_TITLE', { defaultValue: 'Click to view order references' })}
        >
          <>
            {ids.accountNames.length > 0 && (
              <>
                <P2GChip size="small" label={ids.accountNames.join(' , ')} color="primary" onClick={() => {}} />
                &nbsp;
              </>
            )}
            {ids.refs.length > 0 && (
              <>
                <P2GChip
                  size="small"
                  label={
                    ids.refs.length == 1
                      ? ids.refs[0]
                      : t('ORDER_REFS', { defaultValue: '{{length}} x Order Refs', length: ids.refs.length })
                  }
                  color="primary"
                  onClick={() => {}}
                />
                &nbsp;
              </>
            )}
            {ids.skus.length > 0 && (
              <>
                &nbsp;
                <P2GChip
                  size="small"
                  label={
                    ids.skus.length == 1
                      ? ids.skus[0]
                      : t('ORDER_SKUS', { defaultValue: '{{length}} x SKUs', length: ids.skus.length })
                  }
                  color="info"
                />
              </>
            )}
          </>
        </P2GTooltip>
      }
    >
      <P2GBox p={1} bordered>
        <ItemContentsIntro item={props.item} />
      </P2GBox>
    </P2GContentDropDown>
  );
}
